import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import {
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTransloco,
} from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'es'],
        fallbackLang: 'en',
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: location.protocol === 'https:',
      },
    }),
  ],
})
export class TranslocoRootModule {
  constructor(@Optional() @SkipSelf() parentModule: TranslocoRootModule) {
    // Check if NgModule was previously loaded
    // https://angular.io/guide/ngmodule-faq#how-can-i-tell-if-an-ngmodule-or-service-was-previously-loaded
    if (parentModule) {
      throw new Error('TranslocoRootModule is already loaded. Import it in the AppModule only');
    }
  }
}
